import { render, staticRenderFns } from "./ConteudoCliente.vue?vue&type=template&id=1424ce53"
import script from "./ConteudoCliente.vue?vue&type=script&lang=js"
export * from "./ConteudoCliente.vue?vue&type=script&lang=js"
import style0 from "./ConteudoCliente.vue?vue&type=style&index=0&id=1424ce53&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports